import { isEmpty, isEqual, isNumber, map } from 'lodash';
import React, { FC } from 'react';
import { Message } from '../Message';
import { mqTaken } from './card.utils';
import { MQButton } from './MQButton';
import { ProductCardProps } from './ProductCard';
import { ProductCardAttributes } from './ProductCardAttributes';
import { sanitizeDOM } from '@trip-ux/common';

export const DefaultCardContent: FC<
  ProductCardProps & {
    setShowDetails: (details: boolean) => void;
  }
> = ({
  className,
  name,
  summary,
  isMqRequired,
  isMqTaken,
  genericLabels,
  values,
  onParamChange,
  deductibles,
  sumInsuredAfterNeeded,
  tripDays,
  id,
  premium,
  amount,
  optBenAmountBreakdown,
  mqAction,
  paxId,
  setShowDetails,
  tooltips
}) => (
  <div
    className={`product-card-content d-flex flex-column alt-primary-semi-dark-brd-active
            ${className}`}>
    <h3 dangerouslySetInnerHTML={{ __html: sanitizeDOM(name) }} />
    <p dangerouslySetInnerHTML={{ __html: sanitizeDOM(summary) }} />
    {isMqRequired && !isMqTaken && (
      <Message variant="secondary-info">
        <legend>{genericLabels.mqAlert}</legend>
      </Message>
    )}
    <div className="product-card-content-grow">
      {mqTaken(isMqRequired, isMqTaken) && (
        <ProductCardAttributes
          genericLabels={genericLabels}
          values={values}
          onAction={(type, val) => {
            const newVal = { ...values, [type]: val };
            !isEqual(values, newVal) && onParamChange(newVal);
          }}
          deductibles={deductibles}
          sumInsuredAfterNeeded={sumInsuredAfterNeeded}
          tripDays={tripDays}
          id={id}
          isMQtaken={mqTaken(isMqRequired, isMqTaken)}
          tooltips={tooltips}
        />
      )}
    </div>
    {isNumber(premium) && mqTaken(isMqRequired, isMqTaken) && (
      <h3 className="my-2" data-testid="product-amount">
        {amount}
      </h3>
    )}
    {!isEmpty(optBenAmountBreakdown) && (
      <div data-testid="opt-ben-amount-breakdown">
        {map(optBenAmountBreakdown, optBenAmount => (
          <p className="opt-ben-breakdown" data-testid={`opt-ben-amount-${optBenAmount.referenceNumber}`}>
            {optBenAmount.premiumTotalLabel}
          </p>
        ))}
      </div>
    )}
    <a
      href="#view"
      className="primary-clr primary-clr-hover my-2"
      onClick={e => {
        e.preventDefault();
        setShowDetails(true);
      }}
      data-testid={`${id}-view-details`}
      id={`${id}-view-details`}
      aria-label={`${name} ${genericLabels.viewDetails}`}>
      {genericLabels.viewDetails}
    </a>
    {isMqRequired && isMqTaken && (
      <MQButton
        id={`${id}-mq-button`}
        genericLabels={genericLabels}
        isMqTaken={isMqTaken}
        mqAction={mqAction}
        paxId={paxId}
      />
    )}
  </div>
);
DefaultCardContent.displayName = 'DefaultCardContent';
export default DefaultCardContent;
